export function applySuperobjectTypeIdSubstitution(
  template: string,
  superobjectTypeId: string,
  parentSuperobjectTypeId: string | null): string {
  const quotedPlaceholder = '"{superobject_type_id}"';
  if (parentSuperobjectTypeId) {
    const orGroup = `("${superobjectTypeId}" OR "${parentSuperobjectTypeId}")`;
    if (template.includes(quotedPlaceholder)) {
      return template.replace(quotedPlaceholder, orGroup);
    }
    return template.replace('{superobject_type_id}', orGroup);
  }
  return template.replace('{superobject_type_id}', superobjectTypeId);
}
